module.exports = __webpack_public_path__ + "assets/images/emergency.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/emergency.png
// module id = 249
// module chunks = 1